<template>
  <nav class="app-toolbar">
    <img
      src="@/assets/img/logo.svg"
      alt="Venda e Ganhe Logo"
      class="app-toolbar__logo"
    />

    <div class="user">
      <div class="user__name">{{ userName }}</div>
      <img
        :src="user.picture || defaultPicture"
        alt="Imagem do Usuário"
        class="user__picture"
      />
      <div class="user__menu">
        <ul>
          <li>{{ user.email }}</li>
          <li @click="onClickLogout">
            <b-icon size="is-small" icon="logout"></b-icon>Sair
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { AUTH_LOGOUT } from '@/store/actions/auth';

export default {
  name: 'app-toolbar',
  data: () => {
    return {
      defaultPicture: require('@/assets/img/default_user.png'),
    };
  },
  methods: {
    onClickLogout() {
      this.$buefy.dialog.confirm({
        message: 'Tem certeza que deseja sair do sistema?',
        cancelText: 'Cancelar',
        confirmText: 'Sim, sair',
        type: 'is-primary',
        onConfirm: () => this.logout(),
      });
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'));
    },
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    userName() {
      return this.$store.getters.userName;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #f4f5fa;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  padding: 12px 16px 12px 32px;
  height: var(--toolbar-height);

  &__logo {
    width: 160px;
  }

  .user {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;

    &__name {
      font-weight: 600;
      margin-right: 8px;
    }

    &__picture {
      height: 56px;
      width: 56px;
      object-fit: contain;
      border-radius: 50%;
    }

    &:hover {
      .user__menu {
        display: unset;
      }
    }

    &__menu {
      display: none;
      position: absolute;
      top: 99%;
      right: 16px;
      padding-top: calc(1% + 16px);

      &:hover {
        display: unset;
      }

      ul {
        background: #fff;
        min-width: 250px;
        border-radius: 8px;
        box-shadow: 0 2px 14px rgba(0, 0, 0, 0.1);

        li {
          padding: 16px;

          .icon {
            margin-right: 6px;
          }

          &:first-child {
            font-size: 0.9em;
            color: #828282;
            border-bottom: 1px solid #e3e4e6;
          }

          &:not(:first-child) {
            cursor: pointer;

            &:hover {
              background: rgba(0, 0, 0, 0.02);
            }
          }
        }
      }
    }
  }
}
</style>
